import { Select } from 'browser/components/atomic-elements/atoms/select'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
export const SelectField = LabelFieldFactory({ InputComponent: Select })
